import ModalDiscardCart from './ModalDiscardCart';

export default ModalDiscardCart;
